import { Box, Typography, useTheme } from "@outschool/backpack";
import { usePriceDetailsString } from "@outschool/ui-components-website";
import React from "react";

import { CoinIcon } from "../../subscriptions/CoinIcon";
import { FreeForMembersChip } from "./FreeForMembersChip";
import { SearchActivityType } from "./ListingDetails";

/**
 * Copy of the PriceDetails component, but with a different layout for the gallery experiment.
 */
export default function PriceDetails({
  activity,
  showCredits,
}: {
  activity: SearchActivityType;
  showCredits: boolean;
}) {
  const { perClassString, perMeetingPriceString } = usePriceDetailsString();
  const theme = useTheme();
  return (
    <Box
      flex
      sx={{
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.5em",
      }}
    >
      {activity.isIncludedWithMembership ? (
        <FreeForMembersChip />
      ) : (
        <Box flex sx={{ gap: "0.5em" }}>
          <Typography variant="display3" emphasized color={"grey.900"}>
            {showCredits ? (
              <Box sx={{ display: "flex" }}>
                <Box sx={{ paddingTop: "0.25rem", paddingRight: "0.5rem" }}>
                  <CoinIcon
                    fillColor={theme.palette.warning?.main!}
                    strokeColor={theme.palette.warning?.[700]!}
                    width={20}
                    height={20}
                  />
                </Box>
                {activity.priceCreditsPerMeeting}
              </Box>
            ) : (
              perMeetingPriceString(activity)
            )}
          </Typography>
          <Typography
            variant="caption"
            sx={{ alignSelf: "center", color: "grey.600" }}
          >
            {perClassString(activity)}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
